import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getCaptions, getIsCaptionsOpen } from './selectors';
import { localeService } from '../core';
/**
 * Provides memoized formatted captions, translated text, and bottom offset
 */
export const useCaptions = () => {
    const captions = useSelector(getCaptions);
    const isCaptionsOpen = useSelector(getIsCaptionsOpen);
    const formattedCaptions = useMemo(() => {
        if (captions.length === 0) {
            return [];
        }
        return captions.map((caption, index) => ({
            id: `caption-${index}`,
            text: caption.caption,
        }));
    }, [captions]);
    const bottomOffset = 100;
    // For some unknown reason, not memoizing these causes an infinite loop
    const translatedText = useMemo(() => ({
        closeText: localeService.formatMessageById('closedCaptions.closeText'),
        returnText: localeService.formatMessageById('closedCaptions.returnText'),
        waitingText: localeService.formatMessageById('closedCaptions.waitingText'),
    }), []);
    return {
        captions,
        isCaptionsOpen,
        formattedCaptions,
        bottomOffset,
        translatedText,
    };
};
